<template>
  <v-dialog :value="open" max-width="50vw" persistent>
    <v-card>
      <v-card-title>
        <h2 v-html="$t(`message.${type}.redirect.title`)"></h2>
      </v-card-title>
      <v-card-text>
        <template v-for="(field, index) in config.form">
          <nx-form-generator-scope
            :key="index"
            :config="field"
            :show-tabs="false"
            :value="value"
            @input="onInput"
            @form="isValid = $event.valid"
            ref="form"
          ></nx-form-generator-scope>
        </template>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="$emit('click:cancel')" :disabled="loading" flat color="primary">Cancelar</v-btn>
        <v-btn
          @click="$emit('click:confirm')"
          :loading="loading"
          :disabled="!isValid"
          flat
          color="info">Despublicar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import NxFormGeneratorScope from '@/modules/form/FormScopeGenerator';

export default {
  components: { NxFormGeneratorScope },
  props: {
    open: Boolean,
    type: String,
    value: Object,
    config: Object,
    loading: Boolean,
    currentUrl: String,
  },
  data() {
    return {
      isValid: false,
    };
  },
  methods: {
    onInput(field, value) {
      this.$emit('input', field, value);
    },
  },
};
</script>
